import { lazy } from 'react';

export const LazyDocumentation = lazy(() => import('@/pages/Documentation'));